export default __webpack_public_path__ + "static/media/IntegrationWP.0c71bac9.jpg";